export default "__VITE_ASSET__4559bcc2__"